import { useCallback, useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Beginner from "../components/pages/Beginner";
import Contact from "../components/pages/Contact";
import ContentFixedPreview from "../components/pages/ContentFixedPreview";
import ContentPreview from "../components/pages/ContentPreview";
import Error from "../components/pages/Error";
import EventInvitation from "../components/pages/EventInvitation";
import Faq from "../components/pages/Faq";
import Information from "../components/pages/Information";
import InformationList from "../components/pages/InformationList";
import Login from "../components/pages/Login";
import MailAddressConfirm from "../components/pages/MailAddressConfirm";
import MemberEdit from "../components/pages/MemberEdit";
import MemberEntry from "../components/pages/MemberEntry";
import MemberPremium from "../components/pages/MemberPremium";
import News from "../components/pages/News";
import PointHistory from "../components/pages/PointHistory";
import PointRequest from "../components/pages/PointRequest";
import Privacy from "../components/pages/Privacy";
import Referral from "../components/pages/Referral";
import ResetPassword from "../components/pages/ResetPassword";
import ResetPasswordMailAddressConfirm from "../components/pages/ResetPasswordMailAddressConfirm";
import StaticError from "../components/pages/StaticError";
import Survey from "../components/pages/Survey";
import Term from "../components/pages/Term";
import Top from "../components/pages/Top";
import Video from "../components/pages/Video";
import { LoginUserContext } from "../providers/LoginUserProvider";
import usePageTracking from "../utils/useTracking";

import { TApiTrackingRequestBody } from "../api/tracking";
import Chat from "../components/pages/Chat";
import ChatOff from "../components/pages/ChatOff";
import { FilesPage } from "../components/pages/Files";
import { FolderPage } from "../components/pages/Folder";
import MemberEntryNomal from "../components/pages/MemberEntryNomal";
import MemberIdentification from "../components/pages/MemberIdentification";
import { MyPage } from "../components/pages/MyPage";
import NewsList from "../components/pages/NewsList";
import StaticDetail from "../components/pages/StaticDetail";
import SurveyKodate from "../components/pages/SurveyKodate";
import SurveyMansion from "../components/pages/SurveyMansion";
import TopPreview from "../components/pages/TopPreview";
import VideoList from "../components/pages/VideoList";
import useUserSession from "../hooks/useUserSession";
import { SiteContext } from "../providers/SiteProvider";
import { postTracking } from "../utils/api/postTrackingRequest";
import {
  NotificationStatus,
  getNotificationPermissionAndToken,
  useFireBaseCloudMessage,
  syncFCMToken,
} from "../hooks/useFireBaseCloudMessage";
import {
  LIB_STORAGE_PUSH_NOTIFICATION_KEY,
  getDeviceId,
} from "../components/organisms/PushNotificationModal";
import { postNotificationPushMemberRequest } from "../utils/api/postPushNotificationPushMember";
import { MyList } from "../components/pages/MyList";
import { MyPageMessageBoard } from "../components/pages/MyPageMessageBoard";
import isPWA from "../utils/checkPWA";
import CreateBoard from "../components/pages/CreateBoard";
import BoardDetail from "../components/pages/BoardDetail";
import EditBoard from "../components/pages/EditBoard";
import BoardCategoriesForumPage from "../components/pages/BoardCategoriesForumPage";
import ForumCategoryPage from "../components/pages/ForumCategoryPage";

export const routes = {
  top: {
    title: "トップページ",
    router: "/",
    path: "/",
    isPrivate: true,
    component: <Top />,
  },
  newsDetail: {
    router: "/news/:id",
    path: (id: string) => `/news/${id}`,
    isPrivate: true,
    component: <News />,
  },
  news: {
    title: "お知らせ・記事一覧",
    router: "/news",
    path: "/news",
    isPrivate: true,
    component: <NewsList />,
  },
  videos: {
    title: "お知らせ・記事一覧",
    router: "/videos",
    path: "/videos",
    isPrivate: true,
    component: <VideoList />,
  },
  informationDetail: {
    router: "/information/:id",
    path: (id: string) => `/information/${id}`,
    isPrivate: true,
    component: <Information />,
  },
  videoDetail: {
    router: "/video/:id",
    path: (id: string) => `/video/${id}`,
    isPrivate: true,
    component: <Video />,
  },
  informations: {
    title: "お知らせ・記事一覧",
    router: "/informations",
    path: "/informations",
    isPrivate: true,
    component: <InformationList />,
  },
  informationList: {
    title: "お知らせ・記事一覧",
    router: "/informations?list=true",
    path: "/informations?list=true",
    isPrivate: true,
    component: <InformationList />,
  },
  mypage: {
    title: "マイページ",
    router: "/mypage",
    path: "/mypage",
    isPrivate: true,
    component: <MyPage />,
  },
  mylist: {
    title: "保存済み/いいね",
    router: "/mylist",
    path: "/mylist",
    isPrivate: true,
    component: <MyList />,
  },
  messageBoardMyPage: {
    title: "保存済み/いいね",
    router: "/mypage/message-board",
    path: "/mypage/message-board",
    isPrivate: true,
    component: <MyPageMessageBoard />,
  },
  files: {
    title: "ファイル",
    router: "/files",
    path: "/files",
    isPrivate: true,
    component: <FilesPage />,
  },
  forder: {
    title: "フォルダ",
    router: "/files/:folderId",
    path: "/files/:folderId",
    isPrivate: true,
    component: <FolderPage />,
  },
  pointRequest: {
    title: "ポイント申請",
    router: "/point_request",
    path: "/point_request",
    isPrivate: true,
    component: <PointRequest />,
  },
  pointHistory: {
    title: "ポイント履歴",
    router: "/point_history",
    path: "/point_history",
    isPrivate: true,
    component: <PointHistory />,
  },
  memberEdit: {
    title: "会員情報変更",
    router: "/members/edit",
    path: "/members/edit",
    isPrivate: true,
    component: <MemberEdit />,
  },
  login: {
    title: "ログイン",
    router: "/login",
    path: "/login",
    isPrivate: false,
    component: <Login />,
  },
  contact: {
    title: "お問合せ",
    router: "/contact",
    path: "/contact",
    isPrivate: false,
    component: <Contact />,
  },
  chat: {
    title: "チャット",
    router: "/chat",
    path: "/chat",
    isPrivate: true,
    component: <Chat />,
  },
  memberEntrySkip: {
    title: "本登録入力フォーム",
    router: "/members/entry/:id/:datetimeHash",
    path: (id: string, datetimeHash: string) =>
      `/members/entry/${id}/${datetimeHash}`,
    isPrivate: false,
    component: <MemberEntry />,
  },
  memberEntry: {
    title: "本登録入力フォーム",
    router: "/members/entry",
    path: "/members/entry",
    isPrivate: false,
    component: <MemberEntryNomal />,
  },
  memberIdentification: {
    title: "メール認証完了",
    router: "/members/identification/:id/:datetimeHash",
    path: (id: string, datetimeHash: string) =>
      `/members/identification/${id}/${datetimeHash}`,
    isPrivate: false,
    component: <MemberIdentification />,
  },
  mailAddressConfirm: {
    title: "ご本人様確認",
    router: "/members/mailAddressConfirm",
    path: "/members/mailAddressConfirm",
    isPrivate: false,
    component: <MailAddressConfirm />,
  },
  resetPassword: {
    title: "パスワードリセット",
    router: "/reset_password/entry/:id/:datetimeHash",
    path: (id: string, datetimeHash: string) =>
      `/reset_password/entry/${id}/${datetimeHash}`,
    isPrivate: false,
    component: <ResetPassword />,
  },
  resetPasswordMailAddressConfirm: {
    title: "パスワード変更",
    router: "/reset_password/mailAddressConfirm",
    path: "/reset_password/mailAddressConfirm",
    isPrivate: false,
    component: <ResetPasswordMailAddressConfirm />,
  },
  eventInvitation: {
    title: "イベント申し込みフォーム",
    router: "/event_invitation/:eventId",
    path: (id: string) => `/event_invitation/${id}`,
    isPrivate: false,
    component: <EventInvitation />,
  },
  staticDetail: {
    router: "/static/:slug",
    path: (slug: string) => `/static/${slug}`,
    isPrivate: false,
    component: <StaticDetail />,
  },
  staticError: {
    title: "エラー",
    router: "/staticError",
    path: "/staticError",
    isPrivate: false,
    component: <StaticError />,
  },
  faq: {
    title: "よくあるご質問",
    router: "/faq",
    path: "/faq",
    isPrivate: false,
    component: <Faq />,
  },
  beginner: {
    title: "初めての方へ",
    router: "/beginners",
    path: "/beginners",
    isPrivate: false,
    component: <Beginner />,
  },
  term: {
    title: "利用規約",
    router: "/kiyaku",
    path: "/kiyaku",
    isPrivate: false,
    component: <Term />,
  },
  privacy: {
    title: "プライバシーポリシー",
    router: "/privacy",
    path: "/privacy",
    isPrivate: false,
    component: <Privacy />,
  },
  memberPremium: {
    title: "会員優待特典について",
    router: "/member_premium",
    path: "/member_premium",
    isPrivate: false,
    component: <MemberPremium />,
  },
  referral: {
    title: "紹介",
    router: "/referral",
    path: "/referral",
    isPrivate: false,
    component: <Referral />,
  },
  survey_kodate: {
    title: "アンケート/戸建て",
    router: "/survey_kodate",
    path: "/survey_kodate",
    isPrivate: false,
    component: <SurveyKodate />,
  },
  survey_mansion: {
    title: "アンケート/マンション",
    router: "/survey_mansion",
    path: "/survey_mansion",
    isPrivate: false,
    component: <SurveyMansion />,
  },
  survey: {
    title: "アンケート",
    router: "/survey/:id",
    path: (id: string) => `/survey/${id}`,
    isPrivate: false,
    component: <Survey />,
  },
  contentFixedPreview: {
    title: "固定ページプレビュー",
    router: "/contents/fixed/preview/:key",
    path: (key: string) => `/contents/fixed/preview/${key}`,
    isPrivate: false,
    component: <ContentFixedPreview />,
  },
  SitePreview: {
    title: "TOPページプレビュー",
    router: "/site/preview",
    path: (key: string) => `/site/preview?key=${key}`,
    isPrivate: false,
    component: <TopPreview />,
  },
  contentPreview: {
    title: "記事プレビュー",
    router: "/contents/preview/:key",
    path: (key: string) => `/contents/preview/${key}`,
    isPrivate: false,
    component: <ContentPreview />,
  },
  chatOff: {
    title: "チャット機能OFF",
    router: "/chat_off",
    path: "/chat_off",
    isPrivate: false,
    component: <ChatOff />,
  },
  createBoard: {
    title: "ボード",
    router: "/message-board/board/create",
    path: "/message-board/board/create",
    isPrivate: true,
    component: <CreateBoard />,
  },
  forumCategory: {
    title: "カテゴリ詳細",
    router: "/message-board/categories/:category_id",
    path: (category_id: number) => `/message-board/categories/${category_id}`,
    isPrivate: true,
    component: <ForumCategoryPage />,
  },
  editBoard: {
    title: "ボード",
    router: "/message-board/categories/:category_id/:board_id/edit",
    path: (category_id: string, board_id: string) =>
      `/message-board/categories/${category_id}/${board_id}/edit`,
    isPrivate: true,
    component: <EditBoard />,
  },
  boardDetail: {
    title: "ボードの詳細",
    router: "/message-board/categories/:category_id/:board_id",
    path: (category_id: string, board_id: string) =>
      `/message-board/categories/${category_id}/${board_id}`,
    isPrivate: true,
    component: <BoardDetail />,
  },
  boardCategoriesForumPage: {
    title: "掲示板のカテゴリ",
    router: "/message-board/categories",
    path: "/message-board/categories",
    isPrivate: true,
    component: <BoardCategoriesForumPage />,
  },
  error: {
    title: "エラー",
    router: "/error",
    path: "/error",
    isPrivate: false,
    component: <Error />,
  },
};

export const Router = () => {
  usePageTracking();
  const { loginUser = {} as any, member } = useContext(LoginUserContext);
  const isUsingPwa = isPWA();
  const email = loginUser?.email ?? "";
  const site = useContext(SiteContext);
  const location = useLocation();
  useUserSession(location);
  useFireBaseCloudMessage(loginUser);
  //サイトアクセス時のパラメーターを取得
  const queryString = window.location.search;

  const handlePushMember = async () => {
    const token = await getNotificationPermissionAndToken();
    if (token) {
      const uid = getDeviceId();
      await postNotificationPushMemberRequest(
        uid,
        token ?? "",
        Number(site.contractCompanyId),
        email,
        Number(!!token)
      );
    }
    const item = {
      acceptPermission: !!token,
    };
    localStorage.setItem(
      LIB_STORAGE_PUSH_NOTIFICATION_KEY,
      JSON.stringify(item)
    );
  };

  const handleUpdateNotifcationStatus = async (
    isAllowNotication: boolean,
    libDeviceId: string
  ) => {
    const token = await getNotificationPermissionAndToken();
    await postNotificationPushMemberRequest(
      libDeviceId,
      token ?? "",
      Number(site.contractCompanyId),
      email,
      Number(!!isAllowNotication)
    );
    const item = {
      acceptPermission: isAllowNotication,
    };
    localStorage.setItem(
      LIB_STORAGE_PUSH_NOTIFICATION_KEY,
      JSON.stringify(item)
    );
  };

  const handleNotification = useCallback(async () => {
    try {
      const currentPermissionStr = localStorage.getItem(
        LIB_STORAGE_PUSH_NOTIFICATION_KEY
      );
      const libDeviceId = localStorage.getItem("LibDeviceId");
      const token = await getNotificationPermissionAndToken(true);
      const currentSystemPermission = Notification.permission;
      const actualPermissionStatus =
        currentSystemPermission === NotificationStatus.GRANTED && !!token;
      if (currentPermissionStr) {
        const storedSettings = JSON.parse(currentPermissionStr);

        // ケース1: 以前「許可」として保存されているが、現在は許可状態でない場合
        if (storedSettings.acceptPermission && !actualPermissionStatus) {
          if (libDeviceId) {
            await handleUpdateNotifcationStatus(false, libDeviceId);
          }
          return;
        }

        // ケース2: 以前「拒否」として保存されているが、現在は許可状態の場合
        if (!storedSettings.acceptPermission && actualPermissionStatus) {
          if (libDeviceId) {
            await handleUpdateNotifcationStatus(true, libDeviceId);
          } else {
            await handlePushMember();
          }
          return;
        }
      } else if (actualPermissionStatus) {
        // 保存状態が存在しない場合で、実際に許可状態ならDB登録処理を実施
        await handlePushMember();
        return;
      }

      // 許可状態の場合、FCMトークンの同期を実行（トークン変更時のみAPIを呼び出す）
      if (actualPermissionStatus) {
        await syncFCMToken(Number(site.contractCompanyId), email);
      }
    } catch (error) {
      console.error("通知権限の確認中にエラーが発生しました:", error);
    }
  }, [email, site.contractCompanyId]);

  useEffect(() => {
    let permissionCheckTimeout: NodeJS.Timeout;

    const checkPermissionChange = async () => {
      if (document.visibilityState === "visible" && member?.uid) {
        permissionCheckTimeout = setTimeout(() => {
          if (isUsingPwa) {
            handleNotification();
          }
        }, 500);
      }
    };
    document.addEventListener("visibilitychange", checkPermissionChange);
    return () => {
      document.removeEventListener("visibilitychange", checkPermissionChange);
      if (permissionCheckTimeout) {
        clearTimeout(permissionCheckTimeout);
      }
    };
  }, [member, handleNotification]);

  useEffect(() => {
    const handleInstall = () => {
      const trackingContent: TApiTrackingRequestBody = {
        uid: member && member.uid ? member.uid : "",
        referrer_uid: null,
        session_uuid: site.uuid,
        url: window.location.href,
        tracking_flg: 1,
        track_event_name: "PWAアプリインストール",
        click_tag: "install",
        referrer: document.referrer,
      };
      postTracking(trackingContent);
    };
    if (member && member.uid && isUsingPwa) {
      handleNotification();
    }
    window.addEventListener("appinstalled", handleInstall);
    return () => {
      window.removeEventListener("appinstalled", handleInstall);
    };
  }, [member]);

  //プッシュ通知クリック用トラッキング
  useEffect(() => {
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const pndId = params.get("pndId");
      if (pndId) {
        const trackingNotificationClick: TApiTrackingRequestBody = {
          uid: null,
          referrer_uid: pndId,
          session_uuid: site.uuid,
          url: window.location.href,
          tracking_flg: 3,
          track_event_name: "プッシュ通知クリック",
          click_tag: "push notification",
          referrer: document.referrer,
        };
        postTracking(trackingNotificationClick);
      }
    }
  }, []);

  if (!site.isPublic) return <Error />;

  return (
    <Switch>
      {Object.entries(routes)
        .map(([_, v]) => v)
        .filter((v) => v.isPrivate)
        .map((route) => {
          if (loginUser) {
            const isForum = route.router.includes("message-board");
            if (isForum && !site.allowForumFeature) {
              return null;
            }
            return (
              <Route exact path={route.router}>
                {route.component}
              </Route>
            );
          } else {
            return (
              <Route
                exact
                path={route.router}
                render={({ location }) => (
                  <Redirect
                    to={{
                      pathname: routes.login.path,
                      state: { from: location },
                    }}
                  />
                )}
              />
            );
          }
        })}
      {Object.entries(routes)
        .map(([_, v]) => v)
        .filter((v) => !v.isPrivate)
        .map((route) => {
          return (
            <Route exact path={route.router}>
              {route.component}
            </Route>
          );
        })}
      <Route component={Error} />
    </Switch>
  );
};
